export default __webpack_public_path__ + "static/media/downArrow.a4637713.svg";